import { render } from "./ModalErroCadastro.vue?vue&type=template&id=db25b270&scoped=true"
import script from "./ModalErroCadastro.vue?vue&type=script&lang=js"
export * from "./ModalErroCadastro.vue?vue&type=script&lang=js"

import "./ModalErroCadastro.vue?vue&type=style&index=0&id=db25b270&scoped=true&lang=css"

import exportComponent from "C:\\Users\\vinicius.martins\\Desktop\\pasta\\teste\\projeto-automacao\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db25b270"]])

export default __exports__